import { useEffect } from "react";

import { useRwgToken } from "~/hooks/use-rwg-token";
import { useProfileData } from "~/queries/profile/useProfile";

/**
 * Syncs the RWG token into the loaded profile. Isolated in its own component
 * under a Suspense boundary because `useRwgToken` relies on `useSearchParams`.
 */
const RwgSync = () => {
  const profile = useProfileData();

  const { updateProfileWithRwgToken } = useRwgToken();

  useEffect(() => {
    if (profile) {
      updateProfileWithRwgToken(profile);
    }
  }, [profile, updateProfileWithRwgToken]);

  return null;
};

export { RwgSync };
